// 异步队列
// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface TaskLinkNode<T = any, E = any> {
  data?: T
  next: undefined | TaskLinkNode
  prev: undefined | TaskLinkNode
  status: 'success' | 'error' | 'wait' | 'end'
  errorData?: E
  resolve?: (value?: unknown) => void
  reject?: (value?: unknown) => void
}
function generateTaskLinkNode<T = any>(next?: TaskLinkNode, prev?: TaskLinkNode): TaskLinkNode<T> {
  return {
    next,
    prev,
    status: 'wait',
    data: undefined,
  }
}
function getLinkNext(vm: TaskLinkNode, num = 10000000) {
  // 默认获取最后一层
  let current = vm
  while (num) {
    const nextItem = vm.next
    if (nextItem) {
      current = nextItem
      num--
    } else {
      break
    }
  }
  return current
}
export function getAsyncQueueObject() {
  let current: TaskLinkNode | null = null // 当前进行项
  async function add<T = any>(fn: () => Promise<T>): Promise<T> {
    // 添加子项
    const linkLastItem = current ? getLinkNext(current) : null
    const newLinkNode = generateTaskLinkNode<T>(undefined, linkLastItem)
    if (!current) {
      current = newLinkNode
    }
    linkLastItem && (linkLastItem.next = newLinkNode)
    return new Promise((resolve, reject) => {
      fn()
        .then((data: T) => {
          newLinkNode.status = 'success'
          newLinkNode.data = data
          newLinkNode.resolve = () => resolve(data)
          excuteTask()
        })
        .catch((e) => {
          newLinkNode.status = 'error'
          newLinkNode.errorData = e
          newLinkNode.reject = () => reject(e)
          excuteTask()
        })
    })
  }
  function excuteTask() {
    if (current.status === 'wait') {
      return
    }
    if (current.status === 'success') {
      current.resolve && current.resolve()
      current.status = 'end'
    }
    if (current.status === 'error') {
      current.reject && current.reject()
      current.status = 'end'
    }
    if (current.next) {
      current = current.next
      excuteTask()
    }
  }

  return {
    asyncQueueAdd: add,
  }
}
